import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";

class Carousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: true,
      width: '90%',
      awardCarouselList: [],
      screen: ''
    };
  }

  componentDidMount() {
    this.setState({
      awardCarouselList: this.props.state.awardCarouselList,
      screen: this.props.state.screen,
    })
  }

  onAwardApply(uid) {
    const urlParams = new URLSearchParams({
      profile: uid ?uid: "",
    }).toString();

    window.open(`#/category?${urlParams}`, "_blank");
  }


  render() {
    const { display, width, awardCarouselList } = this.state;

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      autoplay: true, // Enables auto-slide
      autoplaySpeed: 3000, // Time in milliseconds between slides (default: 3000ms)
      responsive: [
        {
          breakpoint: 1024, // Tablet
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768, // Mobile
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };


    return (
      <div className="slider-container">
        <style>
          {`
            .slider-container {
              text-align: center;
              margin: 20px auto;
              padding: 0 10px; /* Add padding for mobile view */
              max-width: 100%;
            }
            .button {
              margin: 5px;
              padding: 10px 15px;
              background-color: #007bff;
              color: white;
              border: none;
              border-radius: 5px;
              cursor: pointer;
              font-size: 16px;
            }
            .button:hover {
              background-color: #0056b3;
            }
            .slick-prev:before, .slick-next:before {
              color: black;
            }
            .slick-dots {
              bottom: -30px; /* Adjust dot position */
            }
            @media (max-width: 768px) {
              .button {
                font-size: 14px;
                padding: 8px 12px;
              }
              .slider-container h2 {
                font-size: 18px;
              }
            }
          `}
        </style>
        <div
          style={{
            width: `${width}px`,
            display: display ? "block" : "none",
            margin: "0 auto",
          }}
        >
          <Slider {...settings}>

            {awardCarouselList.map((item, i) => (
              <div
                className="slide"
              >
                <img
                  src="static/images/award3.png"
                  alt="Award"
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "contain",
                  }}
                />
                <div
                  className="caption mt-3 mb-1"
                  style={{ minHeight: "50px", color: this.state.screen == "category" ? '#ffff' : '#212529' }} // Ensure consistent height for captions
                >
                  {item.award_name}
                </div>
                <p
                  onClick={(e) =>
                    this.onAwardApply(
                      item.uid
                    )
                  }
                  style={{ marginTop: "10px" }}
                >
                  { }
                  <a className="text-primary" >
                    <button
                      type="button"
                      className="btn btn-light"
                      style={{ marginTop: "10px" }}
                    >
                      Apply{" "}
                      <i className="fa fa-angle-double-right" />
                    </button>
                  </a>
                </p>
              </div>
            ))}
            {/* <div>
              <h3>2</h3>
            </div>
            <div>
              <h3>3</h3>
            </div>
            <div>
              <h3>4</h3>
            </div>
            <div>
              <h3>5</h3>
            </div>
            <div>
              <h3>6</h3>
            </div> */}
          </Slider>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(null, {})(Carousel)
);
